import { render, staticRenderFns } from "./ProjectIntegrationStatusBadge.vue?vue&type=template&id=5e65467c"
import script from "./ProjectIntegrationStatusBadge.vue?vue&type=script&lang=js"
export * from "./ProjectIntegrationStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports